import { IconButton, Menu, MenuItem } from "@material-ui/core";
import { CSSProperties, ReactElement, useRef, useState } from "react";
import { isNullOrUndefined } from "../../utils/CommonFunctions";
import RxButton from "../RxButton";
import styles from "./RxDropDownMenu.module.css";

interface MenuItemObject {
	label: string;
	onClick: () => void;
	style?: CSSProperties;
	className?: string;
}

interface RxDropDownMenuProps {
	icon?: ReactElement;
	label?: string;
	items?: MenuItemObject[];
	style?: CSSProperties;
	className?: string;
}

const RxDropDownMenu = (props: RxDropDownMenuProps) => {
	const buttonRef: any = useRef();
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	const handleMenu = () => {
		setAnchorEl(buttonRef.current);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	// Ekran tasarımları sonrası kullanım olmayacaksa kaldırılacak
	return (
		<div>
			{props.icon && (
				<IconButton
					color="inherit"
					onClick={handleMenu}
					ref={buttonRef}
					style={props.style}
					className={props.className}
				>
					{props.icon}
				</IconButton>
			)}
			{isNullOrUndefined(props.icon) && (
				<RxButton
					label={props.label}
					onClick={handleMenu}
					ref={buttonRef}
					style={props.style}
					className={props.className}
				/>
			)}
			<Menu
				style={{ marginTop: buttonRef?.current?.clientHeight }}
				anchorEl={anchorEl}
				keepMounted
				open={open}
				onClose={handleClose}
			>
				{props.items &&
					props.items.map((item: MenuItemObject, index: number) => (
						<MenuItem
							key={index}
							onClick={() => {
								item.onClick();
							}}
							style={item.style}
							className={item.className}
						>
							{item.label === "seperator" ? (
								<hr className={styles.widthOneHundred} />
							) : (
								item.label
							)}
						</MenuItem>
					))}
			</Menu>
		</div>
	);
};

export default RxDropDownMenu;
